import MainLayout from '@/components/layout/MainLayout.vue';
import { required, numeric, requiredIf } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import axios from "axios";
import $ from "jquery";
import { mapGetters } from "vuex";
import RegionJson from '@/assets/json/region.json';
import TwspNameJson from "@/assets/json/township.json";
import { between } from 'vuelidate/lib/validators';
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "manageClass",

    components: {
        MainLayout,
        DatePicker,
    },

    data() {
        return {
            createClassForm: {
                course_id: '',
                course_title: '',
                fee: '',
                access_type: '1',
                access_options: '1',
                access_expiry_duration: '',
                start_time: '',
                end_time: '',
                start_date: '',
                end_date: '',
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
                monday1: false,
                tuesday1: false,
                wednesday1: false,
                thursday1: false,
                friday1: false,
                saturday1: false,
                sunday1: false,
                class_type: '',
                // checkedDay: [],
                region: '',
                town: ''
            },
            courses: [],
            submitted: false,
            time_invalid_error: false,
            time_equal_error: false,
            date_invalid_error: false,
            submit_permission: false,
            weekend_validation: false,
            weekday_validation: false,
            weekdayweekend_validation: false,
            timePickerOptions: {
                start: "00:00",
                step: "00:15",
                end: "23:45"
            },
            regionArr: RegionJson,
            twspNameJson: TwspNameJson,
            selectedTwspName: "",
            twspName: [],
            disabled: false,
        }
    },

    validations: {
        createClassForm: {
            course_title: {
                required
            },
            fee: {
                numeric,
                required
            },
            access_type: {
                required
            },
            access_options: {
                required: requiredIf(function () {
                    return this.createClassForm.access_type === '2'
                })
            },
            access_expiry_duration: {
                required: requiredIf(function () {
                    return this.createClassForm.access_type === '2' &&
                        this.createClassForm.access_options === '2'
                }),
                between: between(1, 120)
            },
            start_time: {
                required
            },
            end_time: {
                required
            },
            start_date: {
                required
            },
            end_date: {
                required
            },
            class_type: {
                required
            },
        }
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        checkWeekend() {
            this.createClassForm.monday = false;
            this.createClassForm.tuesday = false;
            this.createClassForm.wednesday = false;
            this.createClassForm.thursday = false;
            this.createClassForm.friday = false;
            this.createClassForm.monday1 = false;
            this.createClassForm.tuesday1 = false;
            this.createClassForm.wednesday1 = false;
            this.createClassForm.thursday1 = false;
            this.createClassForm.friday1 = false;
            this.createClassForm.saturday1 = false;
            this.createClassForm.sunday1 = false;
            if (this.createClassForm.saturday == false && this.createClassForm.sunday == false) {
                this.weekend_validation = true;
            } else {
                this.weekend_validation = false;
                this.weekdayweekend_validation = false;
            }
        },

        checkWeekday() {
            this.createClassForm.saturday = false;
            this.createClassForm.sunday = false;
            this.createClassForm.monday1 = false;
            this.createClassForm.tuesday1 = false;
            this.createClassForm.wednesday1 = false;
            this.createClassForm.thursday1 = false;
            this.createClassForm.friday1 = false;
            this.createClassForm.saturday1 = false;
            this.createClassForm.sunday1 = false;
            if (this.createClassForm.monday == false && this.createClassForm.tuesday == false && this.createClassForm.wednesday == false &&
                this.createClassForm.thursday == false && this.createClassForm.friday == false) {
                this.weekday_validation = true;
            } else {
                this.weekday_validation = false;
                this.weekdayweekend_validation = false;
            }
        },

        checkWeekdayWeekend() {
            this.createClassForm.monday = false;
            this.createClassForm.tuesday = false;
            this.createClassForm.wednesday = false;
            this.createClassForm.thursday = false;
            this.createClassForm.friday = false;
            this.createClassForm.saturday = false;
            this.createClassForm.sunday = false;
            if (this.createClassForm.monday1 == false && this.createClassForm.tuesday1 == false && this.createClassForm.wednesday1 == false &&
                this.createClassForm.thursday1 == false && this.createClassForm.friday1 == false && this.createClassForm.saturday1 == false &&
                this.createClassForm.sunday1 == false) {
                this.weekdayweekend_validation = true;
            } else {
                this.weekday_validation = false;
                this.weekday_validation = false;
            }
        },

        time_check() {
            var start_time = moment(this.createClassForm.start_time, "HH:mm").format("HH:mm");
            var end_time = moment(this.createClassForm.end_time, "HH:mm").format("HH:mm");

            if (end_time < start_time) {
                this.time_invalid_error = true;
            } else {
                this.time_invalid_error = false;
            }

            if (end_time == start_time) {
                this.time_equal_error = true;
            } else {
                this.time_equal_error = false;
            }
        },

        date_check() {
            var start_date = this.createClassForm.start_date;
            var end_date = this.createClassForm.end_date;
            if (end_date != '' && end_date < start_date) {
                this.date_invalid_error = true;
            } else {
                this.date_invalid_error = false;
            }
        },
        onChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.createClassForm.course_id = optionValue;
            this.createClassForm.course_title = optionText;
        },

        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.createClassForm.region = Value;
            this.selectedTwspName = "";
            this.createClassForm.town = "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.createClassForm.town = Value;
        },

        submit() {
            if (this.createClassForm.class_type == 1 && this.createClassForm.saturday == false && this.createClassForm.sunday == false) {
                this.weekend_validation = true;
            } else {
                this.weekend_validation = false;
            }

            if (this.createClassForm.class_type == 2 && this.createClassForm.monday == false && this.createClassForm.tuesday == false &&
                this.createClassForm.wednesday == false && this.createClassForm.thursday == false && this.createClassForm.friday == false) {
                this.weekday_validation = true;
            } else {
                this.weekday_validation = false;
            }

            if (this.createClassForm.class_type == 3 && this.createClassForm.monday1 == false && this.createClassForm.tuesday1 == false &&
                this.createClassForm.wednesday1 == false && this.createClassForm.thursday1 == false && this.createClassForm.friday1 == false &&
                this.createClassForm.saturday1 == false && this.createClassForm.sunday1 == false) {
                this.weekdayweekend_validation = true;
            } else {
                this.weekdayweekend_validation = false;
            }

            if (this.time_invalid_error == false && this.time_equal_error == false && this.date_invalid_error == false) {
                if (this.weekend_validation == false && this.weekday_validation == false && this.weekdayweekend_validation == false) {
                    this.submitted = true;
                    this.submit_permission = false;
                    this.weekend_validation = false;
                    this.weekday_validation = false;
                    this.weekdayweekend_validation = false;
                    if (this.$v.createClassForm.$invalid) {
                        return;
                    }
                    this.createClass();
                } else {
                    this.submitted = false;
                }
            } else {
                this.submitted = false;
                this.submit_permission = true;
            }
        },
        createClass() {
            this.disabled = true;
            if (this.createClassForm.class_type == 3) {
                this.monday = this.createClassForm.monday1;
                this.tuesday = this.createClassForm.tuesday1;
                this.wednesday = this.createClassForm.wednesday1;
                this.thursday = this.createClassForm.thursday1;
                this.friday = this.createClassForm.friday1;
                this.saturday = this.createClassForm.saturday1;
                this.sunday = this.createClassForm.sunday1;
            } else {
                this.monday = this.createClassForm.monday;
                this.tuesday = this.createClassForm.tuesday;
                this.wednesday = this.createClassForm.wednesday;
                this.thursday = this.createClassForm.thursday;
                this.friday = this.createClassForm.friday;
                this.saturday = this.createClassForm.saturday;
                this.sunday = this.createClassForm.sunday;
            }
            var request = {
                course_id: this.createClassForm.course_id,
                course_title: this.createClassForm.course_title,
                fee: this.createClassForm.fee,
                access_type: this.createClassForm.access_type,
                access_options: this.createClassForm.access_options,
                access_expiry_duration: this.createClassForm.access_expiry_duration,
                start_time: this.createClassForm.start_time,
                end_time: this.createClassForm.end_time,
                start_date: this.createClassForm.start_date,
                end_date: this.createClassForm.end_date,
                monday: this.monday,
                tuesday: this.tuesday,
                wednesday: this.wednesday,
                thursday: this.thursday,
                friday: this.friday,
                saturday: this.saturday,
                sunday: this.sunday,
                class_type: this.createClassForm.class_type,
                region: this.createClassForm.region,
                town: this.createClassForm.town,
            };
            axios.post("my/class/create", JSON.stringify(request), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then(() => {
                    this.$router.push({
                        name: "manageClass"
                    });
                    this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    this.disabled = false;
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
        },
        getCoursesForClass() {
            // axios.get("teacher/" + this.teacherId + "/course/list" )
            axios.get("my/course/all")
                .then((response) => {
                    this.courses = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },
    },

    mounted() {
        this.getCoursesForClass();
        fetchNotificationCount();

        $("#fee").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });
    }
};
